
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1em","height":"1em","fill":"currentColor","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M16.75 15.17a1 1 0 01.586 1.288l-1.5 4a1 1 0 01-1.873-.702l1.5-4a1 1 0 011.288-.585zM8.75 15.17a1 1 0 01.586 1.288l-1.5 4a1 1 0 01-1.873-.702l1.5-4a1 1 0 011.288-.585zM12.75 15.17a1 1 0 01.586 1.288l-1.5 4a1 1 0 01-1.873-.702l1.5-4a1 1 0 011.288-.585z"}}),_c('path',{attrs:{"d":"M18.804 15.423c.052.18.265.277.414.164A7 7 0 108.562 7.249 5 5 0 005.037 16.6a.464.464 0 00.611-.28l.41-1.09a2.5 2.5 0 014.123-.877.31.31 0 00.435 0 2.5 2.5 0 013.565 0 .31.31 0 00.435 0 2.5 2.5 0 014.187 1.07z"}})])
          )
        }
      }
    